/**
 * Utility functions for identifying special column types in table views.
 * These are used across multiple list/table components (ntap-list, table-list-grid, etc.)
 * to render columns with appropriate icons instead of plain text.
 */

export class ColumnTypeUtils {
  static readonly LOCKED_COLUMN = 'en~jedinica_gradiva~locked';
  static readonly PUBLIC_COLUMN = 'en~jedinica_gradiva~javno_objavljeno';
  static readonly STATUS_COLUMN = 'en~jedinica_gradiva~status_obrade';

  static isLockedColumn(columnName: string): boolean {
    return columnName === ColumnTypeUtils.LOCKED_COLUMN;
  }

  static isPublicColumn(columnName: string): boolean {
    return columnName === ColumnTypeUtils.PUBLIC_COLUMN;
  }

  static isStatusColumn(columnName: string): boolean {
    return columnName === ColumnTypeUtils.STATUS_COLUMN;
  }
}
